module.exports = __webpack_public_path__ + "59e2ffca.png";